/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalendarSettingsPermissionEnum } from './CalendarSettingsPermissionEnum';
import {
    CalendarSettingsPermissionEnumFromJSON,
    CalendarSettingsPermissionEnumFromJSONTyped,
    CalendarSettingsPermissionEnumToJSON,
    CalendarSettingsPermissionEnumToJSONTyped,
} from './CalendarSettingsPermissionEnum';

/**
 * Response for planning permission by institute
 * @export
 * @interface PlanningPermissionResponse
 */
export interface PlanningPermissionResponse {
    /**
     * Unique identifier of the planning permission
     * @type {string}
     * @memberof PlanningPermissionResponse
     */
    id?: string;
    /**
     * Unique identifier of the healthpro
     * @type {string}
     * @memberof PlanningPermissionResponse
     */
    healthproId?: string;
    /**
     * Firstname and lastname of the medical person
     * @type {string}
     * @memberof PlanningPermissionResponse
     */
    name?: string;
    /**
     * 
     * @type {Array<CalendarSettingsPermissionEnum>}
     * @memberof PlanningPermissionResponse
     */
    access?: Array<CalendarSettingsPermissionEnum>;
}

/**
 * Check if a given object implements the PlanningPermissionResponse interface.
 */
export function instanceOfPlanningPermissionResponse(value: object): value is PlanningPermissionResponse {
    return true;
}

export function PlanningPermissionResponseFromJSON(json: any): PlanningPermissionResponse {
    return PlanningPermissionResponseFromJSONTyped(json, false);
}

export function PlanningPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanningPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'healthproId': json['healthproId'] == null ? undefined : json['healthproId'],
        'name': json['name'] == null ? undefined : json['name'],
        'access': json['access'] == null ? undefined : ((json['access'] as Array<any>).map(CalendarSettingsPermissionEnumFromJSON)),
    };
}

export function PlanningPermissionResponseToJSON(json: any): PlanningPermissionResponse {
    return PlanningPermissionResponseToJSONTyped(json, false);
}

export function PlanningPermissionResponseToJSONTyped(value?: PlanningPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'healthproId': value['healthproId'],
        'name': value['name'],
        'access': value['access'] == null ? undefined : ((value['access'] as Array<any>).map(CalendarSettingsPermissionEnumToJSON)),
    };
}

